import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { Modal, ModalBody, ModalFooter } from '../../../../components';
import { useModal } from '../../../../hooks';
import styles from './SelectBankModal.module.scss';
import {
  AnsarIcon,
  CloseOutlinedIcon,
  KeshavarziIcon,
  MellatIcon,
  SamanIcon,
  SarmayehIcon,
  PostBankIcon,
  SinaBankIcon,
  IranzaminIcon,
  EghtesadeNovinIcon,
  AyandehIcon,
  MehreIranIcon,
  DayIcon,
} from '../../../../assets/icons';
import ModalHeader from '../../../Modal/ModalHeader';
import {
  redirectToAutoUpgradeStart,
  setIsSelectBankVisible,
  setSelectedBank,
} from '../../../../redux/payments/payments.actions';
import { toast } from 'react-toastify';
import useTranslation from 'hooks/useTranslation';

const banks = [
  {
    id: '012',
    name: 'بانک ملت',
    icon: MellatIcon,
  },
  {
    id: '016',
    name: 'بانک کشاورزی',
    icon: KeshavarziIcon,
  },
  {
    id: '021',
    name: 'پست بانک ایران',
    icon: PostBankIcon,
  },
  {
    id: '055',
    name: 'بانک اقتصاد نوین',
    icon: EghtesadeNovinIcon,
  },
  {
    id: '056',
    name: 'بانک سامان',
    icon: SamanIcon,
  },
  {
    id: '058',
    name: 'بانک سرمایه',
    icon: SarmayehIcon,
  },
  {
    id: '059',
    name: 'بانک سینا',
    icon: SinaBankIcon,
  },
  {
    id: '063',
    name: 'بانک آینده',
    icon: AyandehIcon,
  },
  {
    id: '062',
    name: 'بانک انصار',
    icon: AnsarIcon,
  },
  {
    id: '066',
    name: 'بانک دی',
    icon: DayIcon,
  },
  {
    id: '069',
    name: 'بانک ایران زمین',
    icon: IranzaminIcon,
  },
  {
    id: '060',
    name: 'مهر ایران',
    icon: MehreIranIcon,
  },
];

const mapState = (state) => ({
  profile: state.userData.profile,
  isOfficialBillNeeded: state.paymentsData.isOfficialBillNeeded,
  selectedPackage: state.paymentsData.selectedPackage,
  selectedDuration: state.paymentsData.selectedDuration,
  discountCode: state.paymentsData.discountCode,
  useCredit: state.paymentsData.useCredit,

  invoiceId: state.paymentsData.invoiceId,
  selectedConversationCount: state.paymentsData.selectedConversationCount,
  isSelectBankVisible: state.paymentsData.isSelectBankVisible,
  selectedBank: state.paymentsData.selectedBank,
});

const SelectBankModal = () => {
  const dispatch = useDispatch();
  const {
    profile,
    isOfficialBillNeeded,
    selectedPackage,
    selectedDuration,
    discountCode,
    useCredit,

    invoiceId,
    selectedConversationCount,
    isSelectBankVisible,
    selectedBank,
  } = useSelector(mapState);
  const [visible, toggle, hideMoal, showModal] = useModal();
  const { getTranslation } = useTranslation('BILLS_LIST');
  const { t } = getTranslation();

  const handleRedirectToAutoUpgrade = () => {
    if (!selectedBank) {
      toast.error(t('CHOOSE_BANK_ERROR'), {
        position: 'bottom-center',
      });
    }
    dispatch(redirectToAutoUpgradeStart({ invoiceId, selectedBank }));
  };

  const handleToggleModal = (event) => {
    if (event) event.preventDefault();
    toggle();
    dispatch(setIsSelectBankVisible(false));
  };

  const handleSetSelectedBank = (bankId) => {
    dispatch(setSelectedBank(bankId));
  };

  useEffect(() => {
    if (isSelectBankVisible) {
      showModal();
      return;
    }
    hideMoal();
  }, [isSelectBankVisible]);

  const renderFooterActions = (
    <div className='modal__container__footer__right'>
      <a
        href='#/'
        className='btn primary'
        id='saveClose'
        onClick={handleRedirectToAutoUpgrade}
      >
        {t('CONTINUE_PURCHASE')}
      </a>
    </div>
  );

  return (
    <>
      <Modal visible={visible}>
        <form onSubmit={handleRedirectToAutoUpgrade} noValidate>
          <ModalHeader title={t('BANK_CHOICE_TITLE')}>
            <img
              className={styles.closeIcon}
              src={CloseOutlinedIcon}
              alt=''
              onClick={handleToggleModal}
            />
          </ModalHeader>
          <ModalBody>
            <section className={styles.selectBankWrapper}>
              {banks.map((bank) => (
                <div
                  key={bank.id}
                  className={clsx(
                    styles.bankItem,
                    bank.id === selectedBank && styles.active
                  )}
                  onClick={(event) => handleSetSelectedBank(bank.id)}
                >
                  <img src={bank.icon} alt='' />
                </div>
              ))}
            </section>
          </ModalBody>
          <ModalFooter>{renderFooterActions}</ModalFooter>
        </form>
      </Modal>
    </>
  );
};

export default SelectBankModal;
